export const inspectPageSlice = <TBundle>(
    data: TBundle[],
    page: number,
    perPage: number = 1,
): TBundle[] => {
    if (data && data.length > perPage) {
        return data.slice((page - 1) * perPage, (page - 1) * perPage + perPage);
    }
    return data;
};